import React, { useState } from "react";
import { LogoCenter } from "../../component/LogoCenter";
import arrowNext from "../../images/arrowNext.svg";
import smallArrow from "../../images/smallArrow.svg";
import { Link } from "react-router-dom";

const SignUpProfile1: React.FC = () => {
  // State for dropdown for category
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownValue, setDropdownValue] = useState<string>("State");
  // State for dropdown for year
  const [Open, setOpen] = useState(false);
  const [dropValue, setDropValue] = useState<string>("1983");

  // State for radio button
  const [radioValue, setRadioValue] = useState<string>("");

  const dropdownOptions = ["Sport", "Fitness", "Yoga"]; // Dropdown options
  const dropOptions = ["1981", "1982", "1983"]; // Drop options

  const handleOptionClick = (option: string) => {
    setDropdownValue(option);
    setIsOpen(false);
  };
  const handleDropOptionClick = (option: string) => {
    setDropValue(option);
    setOpen(false);
  };

  return (
    <div className={`p-[20px] bg-black h-dvh overflow-auto `}>
      <div className="w-full max-w-2xl mx-auto h-full flex flex-col justify-around items-center  overflow-y-auto">
        <LogoCenter />
        <div className="flex flex-col gap-[80px] w-full">
          <div className="flex flex-col justify-center gap-[15px]">
            <h1 className="text-white text-[40px] leading-[95%] uppercase font-light">
              ATHLETE
              <br />
              PROFILE
            </h1>
            <div>
              <input
                type="text"
                className="border border-white focus:outline-none rounded-[50px] bg-transparent text-white text-lg !leading-none p-[16px] font-normal placeholder:text-[#5d5d5d] w-full mb-[15px]"
                placeholder="City"
              />
              <div className="relative">
                <div
                  onClick={() => setIsOpen(!isOpen)}
                  className="bg-transparent text-white text-lg font-normal border border-white rounded-[45px] p-4 flex items-center justify-between cursor-pointer"
                >
                  <p className="w-[90%]">{dropdownValue}</p>

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className={`transform transition-transform ${
                      isOpen ? "rotate-180" : "rotate-0"
                    }`}
                    width="14"
                    height="8"
                    viewBox="0 0 14 8"
                    fill="none"
                  >
                    <path
                      d="M1 0.999999L7 7L13 1"
                      stroke="white"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                {isOpen && (
                  <div className="absolute bg-black border border-white rounded-md mt-2 w-full z-10">
                    {dropdownOptions.map((option) => (
                      <div
                        key={option}
                        onClick={() => handleOptionClick(option)}
                        className={`px-4 py-2 cursor-pointer text-lg font-normal text-white hover:bg-white/50 `}
                      >
                        {option}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
            <div className="flex gap-[15px]">
              <div className="w-1/2 relative border border-white rounded-[15px] p-5 flex flex-col justify-between">
                <p className="text-white text-lg font-normal">DOB</p>
                <div className="flex justify-between items-center">
                  <div
                    onClick={() => setOpen(!Open)}
                    className="cursor-pointer text-white text-[32px] font-normal flex flex-row justify-between w-full items-center"
                  >
                    {dropValue}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className={`transform transition-transform ${
                        Open ? "rotate-180" : "rotate-0"
                      }`}
                      width="14"
                      height="8"
                      viewBox="0 0 14 8"
                      fill="none"
                    >
                      <path
                        d="M1 0.999999L7 7L13 1"
                        stroke="white"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <div className="flex flex-col gap-2">
                    {Open && (
                      <div className="absolute right-4 bottom-0 bg-black border border-white rounded-md w-fit z-10">
                        {dropOptions.map((option) => (
                          <div
                            key={option}
                            onClick={() => handleDropOptionClick(option)}
                            className={`px-4 py-2 cursor-pointer text-lg font-normal text-white hover:bg-white/50 `}
                          >
                            {option}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <form action="" className="flex flex-col gap-[15px] w-[149px]">
                <p className="text-white text-lg font-normal ml-2">Gender</p>
                <div className="flex gap-2 w-full max-w-sm mx-auto justify-between">
                  <label className="flex items-center flex-col space-x-2 cursor-pointer">
                    <input
                      type="radio"
                      name="gender"
                      value="Male"
                      checked={radioValue === "Male"}
                      onChange={() => setRadioValue("Male")}
                      className="hidden"
                    />
                    <span
                      className={`w-[50px] h-[50px] rounded-full ${
                        radioValue === "Male" ? "bg-white" : "bg-[#171717]"
                      }`}
                    ></span>
                    <span className="text-white font-normal mt-[10px] text-sm">
                      Male
                    </span>
                  </label>
                  <label className="flex items-center flex-col space-x-2 cursor-pointer">
                    <input
                      type="radio"
                      name="gender"
                      value="Female"
                      checked={radioValue === "Female"}
                      onChange={() => setRadioValue("Female")}
                      className="hidden"
                    />
                    <span
                      className={`w-[50px] h-[50px] rounded-full ${
                        radioValue === "Female" ? "bg-white" : "bg-[#171717]"
                      }`}
                    ></span>
                    <span className="text-white font-normal mt-[10px] text-sm">
                      Female
                    </span>
                  </label>
                </div>
              </form>
            </div>
          </div>
          <Link
            to="/signupathleteprofile"
            className="bg-white size-[70px] rounded-full flex justify-center items-center hover:bg-white/50 transition-all duration-300 ml-auto"
          >
            <img src={arrowNext} alt="arrow" className="object-contain" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SignUpProfile1;
